export default __webpack_public_path__ + "static/sublimation4-a74b9d9ba2c3ad5434f6964eb2629184.jpg";